import { useState } from "react";
import Modal from "../shared/Modal";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  selectUser,
  setUser,
  setSelectedMenu,
  setSelectedMenuId,
} from "../../redux/features/appData/";
import { toast } from "react-hot-toast";
import { toastFail, toastSuccess } from "../../config";
import "./ModalDeleteWorkspace.css";
import { apiSetCurrentWorkspace, apiDeleteWorkspace } from "../../api";
import { Workspace } from "winslow-core";

type ModalDeleteWorkspaceProps = {
  isOpen: boolean;
  onClose: any;
  workspaceId: string;
};

const ModalDeleteWorkspace = ({
  isOpen = false,
  onClose,
  workspaceId,
}: ModalDeleteWorkspaceProps) => {
  const storeUser = useSelector(selectUser);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [confirmText, setConfirmText] = useState<string>("");
  const [confirmed, setConfirmed] = useState<boolean>(false);

  const handleInput = (e: any) => {
    setConfirmText(e.target.value);
    setConfirmed(e.target.value === "CONFIRM");
  };

  const handleKeyDown = (e: any) => {
    if (e.key === "Enter" && confirmText.length > 0) {
      handleSubmit();
    }
  };

  const handleClose = () => {
    onClose();
  };

  const handleSubmit = async () => {
    if (!storeUser) {
      return;
    }

    if (!confirmed) {
      return;
    }

    if (storeUser.workspaces.length < 2) {
      return;
    }

    const remainingWorkspaces = storeUser.workspaces.filter(
      (workspace: Workspace) => {
        return workspace.id !== workspaceId;
      }
    );

    const newWorkspaceId = remainingWorkspaces[0].id;

    // alert(workspaceId);

    const result = await apiDeleteWorkspace(workspaceId);

    if (!result) {
      console.log("[ModalDeleteWorkspace/handleSubmit] problem deleting");
      toast("Problem deleting workspace", toastFail);
      return;
    }

    // do all the cleanup and switch to new workspace
    // reset the workspace
    const newUser = {
      ...storeUser,
      currentWorkspaceId: newWorkspaceId,
      workspaces: remainingWorkspaces,
    };

    // return;

    await apiSetCurrentWorkspace(storeUser.id, newWorkspaceId);
    dispatch(setUser(newUser));

    // reset the sidebar
    dispatch(setSelectedMenu("unselected"));
    dispatch(setSelectedMenuId(undefined));

    toast("Deleted workspace.", toastSuccess);
    navigate("/home");
    onClose();
  };

  if (!isOpen) {
    return null;
  }

  const hasAnother = storeUser?.workspaces
    ? storeUser?.workspaces.length > 1
    : false;

  return (
    <>
      <Modal isOpen={isOpen} style={null} onClose={handleClose}>
        <div className="delete-workspace-modal-container">
          <div className="delete-workspace-modal-title">
            <h2>Delete Workspace?</h2>
            <span style={{ color: "var(--text-color-secondary)" }}>
              {!hasAnother
                ? "You can not delete this workspace as its your only one."
                : "Confirm you want to delete this workspace by typing CONFIRM below"}
            </span>
          </div>
          {hasAnother && (
            <div className="delete-workspace-modal-confirm">
              <input
                placeholder="Delete Workspace"
                value={confirmText}
                onChange={handleInput}
                disabled={!hasAnother}
              />
            </div>
          )}
          <div className="delete-workspace-modal-buttons">
            <button
              className="delete-workspace-modal-buttons-cancel"
              onClick={handleClose}>
              Cancel
            </button>
            {hasAnother && (
              <button
                onClick={handleSubmit}
                className="delete-workspace-modal-buttons-delete"
                disabled={!confirmed || !hasAnother}>
                Yes, Delete
              </button>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalDeleteWorkspace;
